import {
  CANDIDATE_CandidateSkills_UPDATE_REQUEST,
  CANDIDATE_CandidateSkills_UPDATE_SUCCESS,
  CANDIDATE_CandidateSkills_UPDATE_FAIL,
  DELETE_SKILLS_SUCCESS,
  DELETE_SKILLS_REQUEST,
  DELETE_SKILLS_FAIL,
} from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

// export const CandidateSkillUpdateAction = (data) => {
//     console.log('DATA===> ', data)
//     return function (dispatch) {
//       dispatch({
//         type: CANDIDATE_CandidateSkills_UPDATE_REQUEST,
//         payload: true,
//       });

//       let OPTION = {
//         url: `${process.env.REACT_APP_API_PATH}/ebench/update_skills`,
//         method: "PUT",
//         data: data,
//         headers: {
//           "content-type": "application/json",
//         },
//       };

//       axios(OPTION)
//         .then((res) => {
//           dispatch(updateDashboardContentPre(res.data));

//         })
//         .catch((error) => {
//           dispatch({
//             type: CANDIDATE_CandidateSkills_UPDATE_FAIL,
//             payload: false,
//             error: error,
//             msg: "Failed to load the information",
//           });
//           toast.error(error.response.data.status.message);
//         });
//     };
//   };

export const CandidateSkillUpdateAction = (data) => {
  return async function (dispatch) {
    dispatch({
      type: CANDIDATE_CandidateSkills_UPDATE_REQUEST,
      payload: true,
    });

    let OPTION = {
      url: `${process.env.REACT_APP_API_PATH}/ebench/update_skills`,
      method: "PUT",
      data: data,
      headers: {
        "content-type": "application/json",
      },
    };

    // Return the Axios promise
    return axios(OPTION)
      .then((res) => {
        dispatch(updateDashboardContentPre(res.data));
        // Returning the data might be useful for chaining then() in the caller
        return res.data;
      })
      .catch((error) => {
        dispatch({
          type: CANDIDATE_CandidateSkills_UPDATE_FAIL,
          payload: false,
          error: error,
          msg: "Failed to load the information",
        });
        toast.error(error.response.data.status.message);
        // Re-throw the error to be caught by the caller
        throw error;
      });
  };
};

export const updateDashboardContentPre = (data) => {
  toast.success("Skill updated successfully");
  // window.location.href = '/candidate_dashboard';
  //  setTimeout(()=>{
  //     window.location.href = "/candidate_dashboard";
  //  },2000)
  return {
    type: CANDIDATE_CandidateSkills_UPDATE_SUCCESS,
    result: data.data,
    payload: false,
    msg: "SUCCESS",
  };
};

export const DeleteSkills = (id) => {
  return function (dispatch) {
    dispatch({
      type: DELETE_SKILLS_REQUEST,
      payload: true,
    });

    let OPTION = {
      url: `${process.env.REACT_APP_API_PATH}/ebench/delete_skills?candidateSkills=${id}`,
      method: "DELETE",
      headers: {
        "content-type": "application/json",
      },
    };

    axios(OPTION)
      .then((res) => {
        dispatch(deleteSkillsPre(res.data));
      })
      .catch((error) => {
        dispatch({
          type: DELETE_SKILLS_FAIL,
          payload: false,
          error: error,
          msg: "Failed to load the information",
        });
      });
  };
};
export const deleteSkillsPre = (data) => {
  toast.success("Skill deleted successfully");
  // window.location.href = '/candidate_dashboard';
  // setTimeout(()=>{
  //     window.location.href = "/candidate_dashboard";
  //  },2000)
  return {
    type: DELETE_SKILLS_SUCCESS,
    result: data.data,
    payload: false,
    msg: "SUCCESS",
  };
};
